export default "__VITE_ASSET__1e1a1e91__"